import React, { useState, memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { theme } from '../../styles/theme';
import Filter from '../../components/Filter/Filter';
import { useForm } from 'react-hook-form';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../components/Filter/Filter.styles';
import TextInput from '../../components/TextInput/TextInput';
import SelectOptions from '../../components/SelectOptions/SelectOptions';
import DateInput from '../../components/DateInput/DateInput';
import Button from '../../components/Button/Button';
import { ImSearch } from 'react-icons/im';
import { getWallets } from '../../store/fetchActions/walletsActions';
import Table from '../../components/Table/Table';
import MaskField from '../../components/MaskField/MaskField';
import Wrapper from '../../components/Wrapper/Wrapper';

const { rbmWhite } = theme.colors;

function Wallet() {
  const dispatch = useDispatch();

  const {
    walletsData,
    loadingWallets,
    errorWallets,
    paginationWallets,
    errorMessageWallets,
  } = useSelector((state) => state.wallets);

  const [filterData, setFilterData] = useState('');
  const [filter, setFilter] = useState({
    CPFCNPJ_CLIENT: '',
    SEARCH: '',
    STATUS: '',
    LIMIT: 10,
    PAGE: 1,
    VALOR_MAX: 0,
    VALOR_MIN: 0,
    TIPO_TRANSACAO: '',
    MODO_PAGAMENTO: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    AGENCIA: '',
    CONTA: '',
  });

  const { handleSubmit, control } = useForm({});

  const filterTable = (data) => {
    setFilterData(data);
  };

  useEffect(() => {
    dispatch(getWallets());
  }, []);

  const arrayCategoryTypes = [
    {
      ID: 0,
      NOME: 'Todos',
    },
    {
      ID: 1,
      NOME: 'Fulano',
    },
    {
      ID: 2,
      NOME: 'Ciclano',
    },
    {
      ID: 3,
      NOME: 'Beltrano',
    },
  ];

  const arrayTarifas = [
    {
      ID: 0,
      NOME: 'Todos',
    },
    {
      ID: 1,
      NOME: 'Crédito',
    },
    {
      ID: 2,
      NOME: 'Débito',
    },
  ];

  const header = [
    {
      id: 'data de registro',
      name: 'DATA/HORA',
      align: 'center',
    },
    {
      id: 'nome',
      name: 'NOME',
      align: 'left',
    },
    {
      id: 'cpfcnpj',
      name: 'CPF/CNPJ',
      align: 'left',
    },
    {
      id: 'agencia',
      name: 'AGÊNCIA',
    },
    {
      id: 'conta',
      name: 'CONTA',
    },
    {
      id: 'gerente',
      name: 'GERENTE',
      align: 'left',
    },
    {
      id: 'gestor',
      name: 'GESTOR',
      align: 'left',
    },
    {
      id: 'executivo',
      name: 'EXECUTIVO',
      align: 'left',
    },
    {
      id: 'tipo taxa',
      name: 'TIPO TAXA',
      align: 'center',
    },
    {
      id: 'valor taxa',
      name: 'VALOR TAXA',
      align: 'right',
    },
  ];

  const pageOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  const body = walletsData?.map((wallet) => {
    return {
      data: [
        { info: wallet.DATAHORA, align: 'center' },
        { info: wallet.NOME, align: 'left' },
        { info: wallet.CPFCNPJ, align: 'center' },
        { info: wallet.AGENCIA, align: 'center' },
        { info: wallet.CONTA, align: 'center' },
        { info: wallet.GERENTE, align: 'left' },
        { info: wallet.GESTOR, align: 'left' },
        { info: wallet.EXECUTIVO, align: 'left' },
        { info: wallet.TIPOTAXA, align: 'left' },
        { info: wallet.VALORTAXA, align: 'right' },
      ],
    };
  });

  return (
    <Wrapper title="Relatório de Comissão">
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextInput
                label="Nome ou CPF/CNPJ"
                name={'SEARCH'}
                width={'22.042vw'}
                control={control}
                inputProps={{ role: 'filter-text-input' }}
              />
              <MaskField
                label="Agência"
                name="AGENCIA"
                mask={'9999'}
                width={'22.042vw'}
                control={control}
              />
              <MaskField
                label="Conta"
                name="CONTA"
                mask="999999999999999"
                width={'22.042vw'}
                control={control}
              />
              <DateInput
                label="Data Inicial"
                name={'DATA_INICIAL'}
                margin={'0'}
                control={control}
                width={'3.333vw'}
              />
              <DateInput
                label="Data FInal"
                name={'DATA_FINAL'}
                width={'3.333vw'}
                control={control}
              />
            </FirstFilterLine>
            <FirstFilterLine>
              <SelectOptions
                label="Gerente"
                name={'GERENTE'}
                width={'18.042vw'}
                control={control}
                options={arrayCategoryTypes}
                initialName={'Todas'}
                initialValue={0}
              />
              <SelectOptions
                label="Gestor"
                name={'GESTOR'}
                width={'18.042vw'}
                control={control}
                options={arrayCategoryTypes}
                initialName={'Todas'}
                initialValue={0}
              />
              <SelectOptions
                label="Executivo"
                name={'EXECUTIVO'}
                width={'18.042vw'}
                control={control}
                options={arrayCategoryTypes}
                initialName={'Todas'}
                initialValue={0}
              />
              <SelectOptions
                label="Taxa"
                name={'TAXA'}
                width={'18.042vw'}
                control={control}
                options={arrayTarifas}
                initialName={'Todas'}
                initialValue={0}
              />
              <Button
                backgroundColor={'#303545'}
                width={'16.042vw'}
                hoverBGColor={'#FF557E'}
                hoverColor={rbmWhite}
                color={'white'}
                type="submit"
                margin={'0 1.389vw 0 0'}
                roleName="button-buscar-relatorios"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <h5>Resultados por página</h5>
              <SelectOptions
                control={control}
                options={pageOptions}
                name={'LIMIT'}
                margin={'0 0 0 1.875vw'}
                initialName={10}
                initialValue={10}
              />
              <h5>Total de resultados: 0</h5>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingWallets ? (
          <LoadingContainer>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <Table
            loading={loadingWallets}
            error={errorWallets}
            hasPagination={true}
            filter={filter}
            pagination={paginationWallets}
            setFilter={setFilter}
            errorMessage={errorMessageWallets}
            filterTable={filterTable}
            header={header}
            body={body}
            limit={filter.LIMIT}
          />
        )}
      </div>
    </Wrapper>
  );
}

export default memo(Wallet);
